import { TimeRange } from "./TimeRange";

interface DailyAvailability {
  /** in minutes */
  drivingLessonDuration: number;
  /** in minutes */
  pauseDuration: number;
  numLessonUnits: number;
  numDrivingLessons: number;
  numPauses: number;
}

export function calculateDailyAvailability(
  timeRanges: Array<TimeRange>,
  recommendationSettings: { drivingLessonDuration: number; pauseDuration: number },
): DailyAvailability {
  const { drivingLessonDuration, pauseDuration } = recommendationSettings;
  const lessonUnitsIncrement = drivingLessonDuration / 45;
  const durationIncrement = drivingLessonDuration + pauseDuration;
  let numLessonUnits = 0;
  let numDrivingLessons = 0;
  let numPauses = 0;
  for (const timeRange of timeRanges) {
    let numLessonUnitsInTimeRange = 0;
    let numDrivingLessonsInTimeRange = 0;
    const timeRangeLength = _timeRangeLengthInMinutes(timeRange);
    for (let t = drivingLessonDuration; t <= timeRangeLength; t += durationIncrement) {
      numLessonUnitsInTimeRange += lessonUnitsIncrement;
      numDrivingLessonsInTimeRange += 1;
    }
    numLessonUnits += numLessonUnitsInTimeRange;
    numDrivingLessons += numDrivingLessonsInTimeRange;
    numPauses += numDrivingLessonsInTimeRange <= 1 || pauseDuration === 0 ? 0 : numDrivingLessonsInTimeRange - 1;
  }
  return { drivingLessonDuration, pauseDuration, numLessonUnits, numDrivingLessons, numPauses };
}

function _timeRangeLengthInMinutes(timeRange: TimeRange): number {
  const end = timeRange.end.hour * 60 + timeRange.end.minute;
  const start = timeRange.start.hour * 60 + timeRange.start.minute;
  return end - start;
}
